<template>
  <div :id="componentId" class="sp2-module-4" :style="moduleStyle">
    <div class="sp2-module-4-wrap">
      <div
        v-for="(item, index) in displayList"
        :key="index"
        class="sp2-person-item"
      >
        <div class="sp2-person-avatar-wrap">
          <img
            v-if="item.avatarUrl"
            class="sp2-person-avatar"
            referrerpolicy="no-referrer"
            :src="item.avatarUrl"
          />
          <div v-else class="sp2-person-avatar-placeholder">头像</div>
        </div>
        <div class="sp2-person-name">{{ item.name || '姓名' }}</div>
        <div class="sp2-person-divider" />
        <div class="sp2-person-position">{{ item.position || '职位' }}</div>
      </div>
    </div>

  </div>
</template>

<script>
export default {
  name: 'SpTwoModule4',
  props: {
    componentId: {
      type: String,
      default: 'sp_two_module_4'
    }
  },
  data() {
    return {
      backgroundColor: '#fff',
      list: [
        { avatarUrl: '', name: '宛 枫', position: '中国品牌杂志社 总编辑' },
        { avatarUrl: '', name: '宛 枫', position: '中国品牌杂志社 总编辑' },
        { avatarUrl: '', name: '宛 枫', position: '中国品牌杂志社 总编辑' },
        { avatarUrl: '', name: '宛 枫', position: '中国品牌杂志社 总编辑' },
        { avatarUrl: '', name: '宛 枫', position: '中国品牌杂志社 总编辑' }
      ]
    };
  },
  computed: {
    displayList() {
      return (this.list || []).slice(0, 5);
    },
    moduleStyle() {
      return {
        backgroundColor: this.backgroundColor
      };
    }
  },
};
</script>

<style scoped>
.sp2-module-4 {
  position: relative;
  width: 2000px;
  min-width: 2000px;
  max-width: 2000px;
  left: 50%;
  transform: translateX(-50%);
  padding: 0;
  box-sizing: border-box;
  overflow: hidden;
}

.sp2-module-4-wrap {
  display: flex;
  justify-content: center;
  align-items: flex-start;
  gap: 32.5px;
  width: 2000px;
  padding: 60px 0;
  box-sizing: border-box;
}

.sp2-person-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 254px;
  flex-shrink: 0;
}

.sp2-person-avatar-wrap {
  width: 254px;
  height: 254px;
  border-radius: 50%;
  overflow: hidden;
  flex-shrink: 0;
  background: #e0e0e0;
}

.sp2-person-avatar {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}

.sp2-person-avatar-placeholder {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #909399;
  font-size: 14px;
}

.sp2-person-name {
  width: 238px;
  height: 30px;
  margin-top: 12px;
  font-family: Microsoft YaHei, Microsoft YaHei;
  font-weight: 400;
  font-size: 24px;
  color: #000000;
  line-height: 30px;
  text-align: center;
  font-style: normal;
  text-transform: none;
  overflow: hidden;
}

.sp2-person-divider {
  width: 35px;
  height: 4px;
  margin-top: 6px;
  background: linear-gradient(90deg, #1F48BC 0%, #6592E3 100%);
  border-radius: 2px;
}

.sp2-person-position {
  width: 262px;
  height: 30px;
  margin-top: 6px;
  font-family: Microsoft YaHei, Microsoft YaHei;
  font-weight: 400;
  font-size: 16px;
  color: #666666;
  line-height: 30px;
  text-align: center;
  font-style: normal;
  text-transform: none;
  overflow: hidden;
}
</style>
